import React, { useEffect }  from 'react';
import { Box } from '@mui/system'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom' ;
import { useRecoilState, useRecoilValue_TRANSITION_SUPPORT_UNSTABLE } from 'recoil';
import { historyRouteState } from 'src/store/global/historyState';
import useAuthPatient from 'src/Patient/hooks/useAuthPatient';
import { showModalFamilyGroupState } from 'src/FamilyGroup/atom';
import useFamilyGroupLoader from 'src/FamilyGroup/hooks/useFamilyGroupLoader';

const OptionsUserRegistered = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    //const historyRoute = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(historyRouteState);
    const navigate = useNavigate();

    const { handleLogoutUser } = useAuthPatient()

    const [showModalFamilyGroup, setShowModalFamilyGroup] = useRecoilState(showModalFamilyGroupState);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleLogoutUser();
        handleClose();
        //window.location.href = `${process.env.REACT_APP_ROOT_SERVER_PATH}/login` 
        //historyRoute?.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`)
        navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`)
    }

    const handleMyReservations = () => {
        handleClose()
        //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/reservas`)
        navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/reservas`)
    }

    const handleConfigProfile = () => {
        handleClose()
        //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/editar`)
        navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/editar`)
    }

    let options = [
        {
            title: "Mi Datos",
            onClick: handleConfigProfile
        },
        {
            title: "Mis Reservas",
            onClick: handleMyReservations,
            // divider: true,
        },
        // {
        //     title: "Grupo familiar",
        //     onClick: () => {
        //         handleClose()
        //         setShowModalFamilyGroup(true)
        //     },
        //     divider: true,
        // },
        {
            title: "Cerrar sesión",
            styles: {
                color: "red"
            },
            onClick: () => {
                handleLogout()
            }
        },
    ]

    const { loadFamilyGroup } = useFamilyGroupLoader();

    useEffect(() => {
        if (showModalFamilyGroup) {
            loadFamilyGroup();
        }
    }, [showModalFamilyGroup]);

    return (
        <>
            <Box>
                <IconButton
                    style={{ color: 'white' }}
                    aria-label="more"
                    id="long-button"
                    // aria-controls={open ? 'long-menu' : undefined}
                    // aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {options.map((option) => {
                        let props = {
                            ...option,
                            key: option.title,
                            onClick: option.onClick,
                        }
                        if (option.hasOwnProperty("divider")) {
                            props = {
                                ...props,
                                divider: option.divider,
                            }
                        }
                        return <MenuItem {...props} sx={{ ...option.styles }}>
                            {option.title}
                        </MenuItem>
                    })}
                </Menu>

            </Box>
        </>
    )
}

export default OptionsUserRegistered
